<template>
  <div class="audio-content" v-loading="loading">
    <el-button
      type="primary"
      @click="openEditWin('create')"
      >添加</el-button
    >
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="id" label="ID" width="100"> </el-table-column>
      <el-table-column prop="taskName" label="任务名称"> </el-table-column>
      <el-table-column prop="taskName" label="执行的节目单名称(ID)">
        <template slot-scope="scope">
          <span>{{scope.row.programName}}({{scope.row.programId}})</span>
        </template>
      </el-table-column>
      <el-table-column prop="dateStart" label="开始时间"> </el-table-column>
      <el-table-column prop="dateEnd" label="结束时间"> </el-table-column>
      <el-table-column prop="createTime" label="任务添加时间"> </el-table-column>
      <el-table-column label="任务状态(未启用/已启用)" prop="status">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            :active-value="1"
            :inactive-value="0"
            active-color="#67C23A"
            inactive-color="#aaaaaa"
            @change="changeSetTask(scope.row.id,scope.row.status)"
          />
        </template>
      </el-table-column>
      <el-table-column prop="edit" label="编辑" width="100">
        <template slot-scope="scope">
          <div class="edit-button">
            <i
              @click="openEditWin(scope.row)"
              class="el-icon-edit pointer mar-r10"
            ></i>
            <i
              class="el-icon-delete pointer"
              @click="delItem(scope.row.id)"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageInfo.page"
      :page-sizes="[10, 20, 30, 40, 50, 100]"
      :page-size="pageInfo.pageSize"
      layout="sizes, total, prev, pager, next, jumper"
      :total="cnt_all"
    >
    </el-pagination>

    <!--新增对话框-->
    <el-dialog
      class="dialog600"
      :title="editType === 'create' ? '添加' : '修改'"
      :visible.sync="dialogVisible"
      v-if="dialogVisible"
    >
      <el-form
        :model="editOne"
        label-position="left"
        label-width="120px"
        :rules="editOneRule"
      >
        <div class="form-info">
          <el-form-item label="任务名称" prop="taskName">
            <el-input v-model="editOne.taskName"></el-input>
          </el-form-item>
          <el-form-item label="任务起始日期" prop="date">
            <el-date-picker
              v-model="editOne.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format="yyyy 年 MM 月 dd 日"
              value-format="yyyy-MM-dd">
            </el-date-picker>
          </el-form-item>
   
          <el-form-item label="执行的节目单" prop="programId">
            <el-select
              clearable
              filterable 
              placeholder="请选择节目单"
              v-model="editOne.programId"
              style="width: 100%"
            >
              <el-option
                v-for="t in programList"
                :key="t.id"
                :label="t.programName"
                :value="t.id"
              ></el-option>
            </el-select>
          </el-form-item>

        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="mw-edit-button" @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          type="primary"
          @click="createItem"
          v-if="editType === 'create'"
          >确 定</el-button
        >
        <el-button
          type="primary"
          @click="updateItem"
          v-if="editType === 'update'"
          >确 定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import qs from 'qs'
export default {
  data() {
    return {
      loading: false,
      dialogVisible: false,
      programList: [],
      tableData: [],
      pageInfo: {
        page: 1,
        pageSize: 10,
      },
      cnt_all: 0,
      editOneRule: {
        taskName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        date: [{ required: true, message: "请选择起始日期", trigger: "blur" }],
        programId: [{ required: true, message: "请选择执行的节目单", trigger: "blur" }],
      },
      editType: -1,
      devSelect: [],
      editOne: {
        taskName: '',
        date: [],
        programId: ''
      },
    };
  },
  methods: {
    getTableData(pageIndex) {
      // 获取列表
      this.pageInfo.page = pageIndex
      this.loading = true
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/taskStrategy/manager/listPage',
        method: 'GET',
        params: {
          pageNum: this.pageInfo.page,
          pageSize: this.pageInfo.pageSize
        },
      }).then(res => {
        if (res.data.code === 1000) {
          this.loading = false;
          let resData = res.data.data;
          this.tableData = resData.list;
          this.pageInfo.page = pageIndex;
          this.cnt_all = parseInt(resData.pageCount);
          this.getProgramList()
        }
      })
    },

    handleSizeChange(val) {
      this.pageInfo.pageSize = val;
      this.getTableData(this.pageInfo.page);
    },
    handleCurrentChange(val) {
      this.pageInfo.page = val;
      this.getTableData(this.pageInfo.page);
    },

    openEditWin(index) {
      if (index === "create") {
        this.editOne = {
          taskName: '',
          date: [],
          programId: ''
        };
        this.editType = "create";
      } else {
        console.log('index',index)
        this.editOne = {
          id: index.id,
          taskName: index.taskName,
          programId: parseInt(index.programId)
        };
        this.editOne.date=[index.dateStart,index.dateEnd]
        this.editType = "update";
      }
      this.dialogVisible = true;
    },

    updateItem() {
      this.editOne.dateStart = this.editOne.date[0]
      this.editOne.dateEnd = this.editOne.date[1]
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/taskStrategy/manager/updateTask',
        method: 'post',
        data: qs.stringify(this.editOne)
      }).then(res => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },

    createItem() {
      this.editOne.dateStart = this.editOne.date[0]
      this.editOne.dateEnd = this.editOne.date[1]
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/taskStrategy/manager/saveTask',
        method: 'post',
        data: qs.stringify(this.editOne)
      }).then(res => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.dialogVisible = false;
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    },
    getProgramList() { 
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/programGuides/manager/listPage',
        method: 'GET',
        params: {
          pageNum: 1,
          pageSize: 1000
        },
      }).then(res => {
        if (res.data.code === 1000) {
          let resData = res.data.data;
          this.programList = resData.list;
        }
      })
    },
    delItem(id) {
      this.$confirm("本操作将永久删除该条信息，是否继续？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          axios({
            url: process.env.VUE_APP_BASE_API+'/v1/taskStrategy/manager/deleteTask',
            method: 'post',
            data: qs.stringify({id:id})
          }).then(res => {
            if (res.data.code === 1000) {
              this.$message.success("删除成功");
              this.getTableData(this.pageInfo.page);
            } else {
              this.$message.error(res.data.message);
            }
          })
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    changeSetTask(id, value) {
      let status=0
      if(value){
        status=1
      }
      axios({
        url: process.env.VUE_APP_BASE_API+'/v1/taskStrategy/manager/setTask',
        method: 'post',
        data: qs.stringify({id:id,status:status})
      }).then(res => {
        if (res.data.code === 1000) {
          this.$message.success(res.data.message);
          this.getTableData(this.pageInfo.page);
        } else {
          this.$message.error(res.data.message);
        }
      })
    }
  },
  mounted() {
    this.getTableData(this.pageInfo.page);
  }
};
</script>
<style lang='less' scoped>
.audio-content {
  width: 100%;
}
.map-container {
  padding-left: 100px;
  height: 180px;
  margin-bottom: 10px;
}
</style> 